import { ComponentProps } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useScopedAppFlagStore } from '@frontend/scope';
import { Button, FileUpload, Modal, useModalControl } from '@frontend/design-system';

type ImageButtonProps = {
  addImages: (files: File[]) => void;
} & Partial<Omit<ComponentProps<typeof Button>, 'iconName' | 'children' | 'onClick'>>;

export const ImageButton = ({ addImages, ...rest }: ImageButtonProps) => {
  const { t } = useTranslation('thread-sending-area');
  const { triggerProps, modalProps, closeModal } = useModalControl();
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const mmsEnhancementsEnabled = !!getFeatureFlagValue('nwx:inbox-mms-enhancements');
  const acceptedFileType: ('png' | 'jpg' | 'jpeg' | 'pdf' | 'mp4')[] = mmsEnhancementsEnabled
    ? ['png', 'jpg', 'jpeg', 'pdf', 'mp4']
    : ['png', 'jpg', 'jpeg'];

  return (
    <>
      <Button
        iconName='image'
        variant='tertiary'
        hoverLabel={
          mmsEnhancementsEnabled
            ? t('Upload media (JPG, PNG, PDF, MP4) Depending on your carrier, certain files may not send.')
            : t('Upload media (JPG, PNG) Depending on your carrier, certain files may not send.')
        }
        {...triggerProps}
        {...rest}
      />
      <Modal
        {...modalProps}
        maxWidth={600}
        onDrop={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <Modal.Header textAlign='left'>
          {mmsEnhancementsEnabled ? t('Upload Image, PDF, or Video') : t('Upload Image')}
        </Modal.Header>
        <Modal.Body>
          <FileUpload
            onFileUpload={(files) => {
              addImages(files);
              closeModal();
            }}
            acceptedFileType={acceptedFileType}
            multiple
          />
        </Modal.Body>
      </Modal>
    </>
  );
};
